import React from "react";

import { UseFormReturn } from "react-hook-form";

import {
    Box,
    Button,
    Typography
} from "@mui/material";

import {
    t,
    Trans
} from "@lingui/macro";

import {
    ZPlayLoader,
    NavigationBack
} from "commons";

import { ManageFestivalState } from "./models";
import { DefaultTypedResponse } from "models/response";
import { Festival } from "models";

import { ContentProducerService } from "services/content-producer-service";
import AddIcon from "@mui/icons-material/Add";
import { withSnackbar, WithSnackbarProps } from "notistack";
import { CreateAndEditFestivalModal, FestivalTable } from "components/backoffice/festival";


class ManageFestival extends React.Component<UseFormReturn & WithSnackbarProps, ManageFestivalState>{

    constructor(props: any) {
        super(props);

        this.state = {
            searchFilter: null,
            pagination: { pageSize: 20, pageIndex: 0 },
            festivalCount: 0,
            festivalList: [],
            data: null,
            isLoading: true,
            openEditFestivalModal: false,
            openCreateFestivalModal: false,
            editFestival: null
        };
    }

    public componentDidMount() {
        this.getPaginatedFestivalWithStateParameters();
    };

    private paginationUpdated = (pagination: any) => {

        ////****
        //VERY VERY IMPORTANTE! Mongoose Paginate prende di default come prima pagina la pagina 1, mentre la tabella la pagina 0. Serve questo piccolo workaround
        ////****

        this.setState(() => ({
            isLoading: true,
            pagination: pagination
        }), () => ContentProducerService.getFestivalListPaginated([["pageId", this.state.pagination.pageIndex + 1], ["pageSize", this.state.pagination.pageSize]], this.getFestivalCallback, this.getFestivalErrorCallback));

    }

    private getPaginatedFestivalWithStateParameters = () => {

        this.setState(() => ({
            isLoading: true,
        }));

        ContentProducerService.getFestivalListPaginated([["pageId", this.state.pagination.pageIndex + 1], ["pageSize", this.state.pagination.pageSize]], this.getFestivalCallback, this.getFestivalErrorCallback);
    }

    private deleteFestival = (id: string): void => {

        this.setState(() => ({
            isLoading: true,
        }));

        if ((this.state.festivalList.length - 1) % this.state.pagination.pageSize === 0 && this.state.pagination.pageIndex !== 0) {
            this.setState((prevState) => ({
                pagination: {
                    ...prevState.pagination,
                    pageIndex: this.state.pagination.pageIndex - 1
                }
            }));
        }

        ContentProducerService.deleteFestival(id, this.getPaginatedFestivalWithStateParameters, this.deleteFestivalErrorCallback);
    }


    private getFestivalCallback = (data: DefaultTypedResponse<Festival>): void => {

        this.setState(() => ({
            festivalCount: data.size,
            festivalList: data.list,
            isLoading: false,
        }));
    };

    private editFestivalCallback = (): void => {
        this.setState(() => ({ openEditFestivalModal: false }));
        this.getPaginatedFestivalWithStateParameters();
    };

    private createFestivalCallback = (): void => {
        this.setState(() => ({ openCreateFestivalModal: false }));
        this.getPaginatedFestivalWithStateParameters();
    };

    private deleteFestivalErrorCallback = (err: any): void => {
        this.setState(() => ({
            isLoading: false
        }));

        this.props.enqueueSnackbar(t({
            id: "mf-error-delete-festival",
            message: "Si è verificato un errore. Il festival non è stato eliminato"
        }), {
            variant: "error",
        });
    }

    private getFestivalErrorCallback = (err: any): void => {
        this.setState(() => ({
            isLoading: false
        }));


        this.props.enqueueSnackbar(t({
            id: "mf-error-get-festival",
            message: "Si è verificato un errore."
        }), {
            variant: "error",
        });
    };

    private editFestivalErrorCallback = (err: any): void => {
        this.setState(() => ({
            openEditFestivalModal: false
        }));

        this.props.enqueueSnackbar(t({
            id: "mf-error-edit-festival",
            message: "Si è verificato un errore. Il festival non è stato modificato"
        }), {
            variant: "error",
        });
    };

    private createFestivalErrorCallback = (err: any): void => {
        this.setState(() => ({
            openCreateFestivalModal: false
        }));

        this.props.enqueueSnackbar(t({
            id: "mf-error-create-festival",
            message: "Si è verificato un errore. Il festival non è stato creato"
        }), {
            variant: "error",
        });
    };


    private openEditFestivalModal = (festival: Festival): void => {
        this.setState(() => ({
            openEditFestivalModal: true,
            editFestival: festival
        })
        )
    }

    private closeModal = (): void => {
        this.setState(() => ({
            openEditFestivalModal: false,
            editFestival: null,
            openCreateFestivalModal: false
        }));
    };

    private openCreateFestivalModal = (): void => {
        this.setState(() => ({
            openCreateFestivalModal: true,
        })
        )
    }

    render() {
        return (
            <Box sx={{ textAlign: "center", p: 5 }}>
                <NavigationBack/>
                <Typography variant="h2" color={process.env.REACT_APP_DEFAULT_TEXT_COLOR}>
                    <Trans id="mf-text-title">Festival</Trans>
                </Typography>
                <Box sx={{ textAlign: "right", pr: 2 }}>
                    <Button
                        endIcon={<AddIcon />}
                        onClick={this.openCreateFestivalModal}
                        variant={"contained"}
                    >
                        <Trans id="mf-button-add">Aggiungi</Trans>
                    </Button>
                </Box>
                {<Box sx={{ p: 2, mt: 2 }}>
                    <FestivalTable
                        pagination={this.state.pagination}
                        festivals={this.state.festivalList}
                        totalFestivalCount={this.state.festivalCount}
                        deleteFestival={this.deleteFestival}
                        openEditFestivalTable={this.openEditFestivalModal}
                        updatePaginationCallBackFn={this.paginationUpdated}
                    />
                </Box>}
                {this.state.openEditFestivalModal && <CreateAndEditFestivalModal
                    closeModal={this.closeModal}
                    editFestivalCallback={this.editFestivalCallback}
                    editFestivalErrorCallback={this.editFestivalErrorCallback}
                    festival={this.state.editFestival}
                />}
                {this.state.openCreateFestivalModal && <CreateAndEditFestivalModal
                    closeModal={this.closeModal}
                    createFestivalCallback={this.createFestivalCallback}
                    createFestivalErrorCallback={this.createFestivalErrorCallback}
                />}
                {this.state.isLoading && <ZPlayLoader />}
            </Box>);
    }
}

export default withSnackbar(ManageFestival);